<template>

    <div class="outer-wrapper">

        <LoadingScreen v-if=" menuVersion == null " />
        <div v-else-if=" currentMenuView != null ">

            <transition name="slide" mode="out-in">

                <component :is=" currentMenuView " class="menu-inner-wrap"></component>
            </transition>
        </div>

        <div v-else-if=" menuError != null " class="initial-loading">

            {{ menuError }}
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import Category from './Category';
    import Item from './Item';
    import LoadingScreen from '../misc/LoadingScreen';

    export default {

        name: 'order-menu',
        created() {

            console.log( 'menu view created!' );
            this.$store.dispatch( 'orderMenu/getOrderMenu' );
            if( this.menuVersion != null && this.currentMenuView === null ){

                // console.log( 'setting view to category' );
                this.$store.dispatch( 'orderMenu/chooseCategory', null );
            }
        },
        computed: {

            ...mapGetters({

                currentMenuView : 'orderMenu/currentMenuView',
                menuError       : 'orderMenu/getMenuError',
                menuVersion     : 'orderMenu/menuVersion',
                tabOpen         : 'orderTab/tabOpen',
                isLoading       : 'isLoading'
            })
        },
        components: {

            Category,
            Item,
            LoadingScreen
        }

    }

</script>

<style scoped>

    .outer-wrapper {

        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 100%;
        padding-top: 0px !important;
    }
    .menu-inner-wrap {

        width: 100%;
        margin: 20px auto;
    }
    .bottom-padds {

        padding-bottom: 55px;
    }
    .initial-loading {

        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 1.4rem;
    }
</style>